var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarningYellow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.79951 2.43459C7.34328 1.52831 8.65673 1.52832 9.20049 2.43459L14.9875 12.0797C15.5474 13.0128 14.8753 14.2 13.7871 14.2H2.21295C1.12474 14.2 0.452583 13.0128 1.01246 12.0797L6.79951 2.43459ZM8.1715 3.05198C8.09382 2.92252 7.90618 2.92252 7.8285 3.05198L2.04145 12.6971C1.96147 12.8304 2.0575 13 2.21295 13H13.7871C13.9425 13 14.0385 12.8304 13.9586 12.6971L8.1715 3.05198Z",
    fill: "#F0BE0C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36182 11.1542C7.36182 11.3361 7.43406 11.5105 7.56266 11.6391C7.69125 11.7677 7.86567 11.8399 8.04753 11.8399C8.22939 11.8399 8.40381 11.7677 8.5324 11.6391C8.661 11.5105 8.73325 11.3361 8.73325 11.1542C8.73325 10.9724 8.661 10.7979 8.5324 10.6694C8.40381 10.5408 8.22939 10.4685 8.04753 10.4685C7.86567 10.4685 7.69125 10.5408 7.56266 10.6694C7.43406 10.7979 7.36182 10.9724 7.36182 11.1542ZM7.70467 9.55423H8.39039C8.45325 9.55423 8.50467 9.5028 8.50467 9.43994V5.55423C8.50467 5.49137 8.45325 5.43994 8.39039 5.43994H7.70467C7.64182 5.43994 7.59039 5.49137 7.59039 5.55423V9.43994C7.59039 9.5028 7.64182 9.55423 7.70467 9.55423Z",
    fill: "#F0BE0C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningYellow);
export default __webpack_public_path__ + "static/media/warning_yellow.a9798dc94b5fce71e6dfd1802602e9fd.svg";
export { ForwardRef as ReactComponent };